import cn from 'classnames';

import { defineTheme, ThemeKeys } from 'js/utils/theme-helpers';

import Link from 'components/link/Link';
import Heading from 'components/heading/Heading';
import DocumentIcon from 'components/document-icon/DocumentIcon';
import Image from 'components/image/Image';
import Icon from 'components/icon/Icon';

import DownloadIcon from 'images/download-icon.svg';
import { IDownloadList } from 'source/NFR.types';

const themes = defineTheme({
  narrow: 'download-list--theme-narrow',
  grey: 'download-list--theme-grey',
  prominent: 'download-list--theme-prominent'
});
type Theme = ThemeKeys<typeof themes>;

interface DownloadListProps extends IDownloadList {
  theme?: Theme;
  className?: string;
}

const DownloadList: React.FC<DownloadListProps> = ({
  groups = [],
  downloadAllText,
  downloadAllUrl,
  theme,
  requiredText
}) => {
  return (
    <div className={cn('download-list', themes(theme))}>
      {groups?.map((group, index) => (
        <div className="download-list--group" key={(group.heading ?? '') + index}>
          {group.heading && <Heading className="download-list--heading">{group.heading}</Heading>}
          {group.subheading && <Heading className="download-list--subheading">{group.subheading}</Heading>}
          <ul>
            {group.items?.map(item => (
              <li key={item.text}>
                <Link className="download-list--item" url={item.url} noHoverEffect>
                  <DocumentIcon
                    className="download-list--item-icon"
                    size={theme === 'narrow' ? 'small' : undefined}
                    iconTheme={item.iconTheme}
                    isRequired={item.isRequired}
                  />
                  <div className="download-list--item-text">
                    <div className="download-list--item-text-name">
                      <span>{item.text}</span>
                    </div>
                    <div className="download-list--item-text-size">{item.size}</div>
                  </div>
                  <div className="download-list--download-icon">
                    <Image src={DownloadIcon} alt="ikon" width={32} height={32} isFluid={true} />
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
      {requiredText && (
        <div className="download-list--required">
          <Icon name="asterix" />
          {requiredText}
        </div>
      )}

      <div>
        {downloadAllText && downloadAllUrl && (
          <div className="download-list--download-all">
            <Link
              icon="download-round-large"
              url={downloadAllUrl}
              text={downloadAllText}
              theme={['secondary', 'small']}
              useButtonStyles
            />
          </div>
        )}
      </div>
    </div>
  );
};

DownloadList.displayName = 'DownloadList';

export default DownloadList;
